import type { Product } from "../../../types";
import { u7proOutdoor } from "../u7proOutdoor";

export const u7proOutdoorOverviewVariant: Product = {
  ...u7proOutdoor,
  notes: ["u7proOutdoor.notes.1"],
};
